import { css } from '@/styled-system/css';

export const labelStyles = css.raw({
  textAlign: 'center',
  marginInline: 'tighter',
  width: '50px',
});

export const timeValueStyles = css.raw({
  marginBlock: 'tightest',
  padding: 'tighter',
  cursor: 'pointer',
  textAlign: 'center',
});

export const highlightedTimeValueStyles = css.raw({
  backgroundColor: 'bg.accent.blue.soft',
  borderRadius: '300',
});
